import { useEffect, useState } from 'react';
import { trackEvent } from '~/api/analytics';
import { Box, ConfirmPopup } from '~/commonComponents';
import { ModalOrder, useModal } from '~/components/ModalQueue';
import { getShouldShowChargeTimelineDaysPopup } from '~/growthbook';
import { useUserSelector } from '~/hooks';
import ChargeTimelineDays from '~/images/ChargeTimelineDays.svg';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';

interface IChargeTimelineDaysPopupProps {
  screenName: string;
}

export function ChargeTimelineDaysPopup({ screenName }: IChargeTimelineDaysPopupProps) {
  const user = useUserSelector();
  const [showPopup, setShowPopup] = useState(false);
  const chargeTimelineDays = RemoteConfigUtils.getChargeTimelineDays();
  const chargeTimelineDaysPopupKey = `chargeTimelinePopup-${user?.id}-${screenName}`;

  const getStorage = () => {
    const chargeTimelinePopup = localStorage.getItem(chargeTimelineDaysPopupKey);

    if (chargeTimelinePopup === null) {
      setShowPopup(true);
    }
  };

  const setStorage = () => {
    localStorage.setItem(chargeTimelineDaysPopupKey, 'false');
    setShowPopup(false);
  };

  const handleClose = () => {
    trackEvent('Charge Timeline Beta CTA clicked” on the CTA button on the pop-up');
    setStorage();
  };

  useEffect(() => {
    getStorage();
  }, [user]);

  const { isActive } = useModal({
    id: ModalOrder.CHARGE_TIMELINE_DAYS_POPUP,
    condition: showPopup,
  });

  if (!user) {
    return null;
  }

  return (
    getShouldShowChargeTimelineDaysPopup() &&
    isActive &&
    showPopup &&
    chargeTimelineDays > 0 &&
    user.mdbChargeTimelineDays > 0 &&
    chargeTimelineDays === user.mdbChargeTimelineDays && (
      // @ts-expect-error missing type
      <ConfirmPopup
        dataCy="charge-timeline-popup"
        rightButtonDataCy="charge-timeline-close-button"
        Icon={() => (
          <Box marginBottom={16}>
            <img src={ChargeTimelineDays} alt="charge timeline image" />
          </Box>
        )}
        modalStyle={{
          width: 532,
        }}
        title="Book Now, Pay Later!"
        description={
          <>
            Great news! Your office has been selected for an exclusive Beta test.
            <br />
            During this Beta, professional pay will be charged 7 days before a shift (instead of
            28), giving you more flexibility to plan coverage and better control over cash flow.
            Enjoy access to this new payment timeline through the end of the year.
            <br />
            <br />
            For any questions, contact your GoTu Account Manager.
          </>
        }
        descriptionStyle={{
          marginBottom: 32,
        }}
        closePopup={handleClose}
        rightButtonText="Close"
        rightButtonAction={handleClose}
      />
    )
  );
}
